import { useContext } from 'react';
import { LanguageContext } from 'core';
import { LanguageKeys } from 'app/constants';

import styles from './PrivateLayoutFooter.module.scss';


function PrivateLayoutFooter() {
    const year = new Date().getFullYear();
    const messages = useContext(LanguageContext).messages;

    return (
        <footer className={styles.footer}>
            <div className={styles.footer_content}>
                <small>
                    {messages[LanguageKeys.footerCopyrightTxt].replace(
                        '{year}',
                        year.toString(),
                    )}
                </small>
            </div>
        </footer>
    );
}

export default PrivateLayoutFooter;
